export default __webpack_public_path__ + "static/media/homework-g63a8cdc98_1920.52965822.jpg";